import React from "react";
import styled from "styled-components";

const GOLD = "#C4A25D";

export default function InterestCard({ icon, title, description, link }) {
  return (
    <Card>
      <IconWrap>{icon}</IconWrap>
      <Content>
        <Title>{title}</Title>
        <Desc>{description}</Desc>
        {link && (
          <CardLink href={link.url} target="_blank" rel="noopener noreferrer">
            {link.text} →
          </CardLink>
        )}
      </Content>
    </Card>
  );
}

const Card = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  background: #ffffff;
  border: 1px solid #f3f4f6;
  padding: 1.375rem;
  border-radius: 0.75rem;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.07);
    border-color: #e8d5aa;
  }
`;

const IconWrap = styled.div`
  font-size: 1.75rem;
  line-height: 1;
  flex-shrink: 0;
  margin-top: 0.1rem;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

const Title = styled.h4`
  font-family: 'DM Serif Display', Georgia, serif;
  font-weight: 400;
  font-size: 1.1rem;
  color: #111827;
  margin: 0;
`;

const Desc = styled.p`
  margin: 0;
  color: #6b7280;
  font-size: 0.875rem;
  line-height: 1.65;
`;

const CardLink = styled.a`
  font-family: 'Inter', sans-serif;
  font-size: 0.8rem;
  font-weight: 600;
  color: ${GOLD};
  text-decoration: none;
  margin-top: 0.25rem;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.75;
    color: ${GOLD};
  }
`;
